import { v4 as uuid } from "uuid";

export const upload = {
  namespaced: true,

  state: () => ({
    queue: [],
  }),

  getters: {
    hasActive: (state) => state.queue.length > 0,
  },

  mutations: {
    ADD(state, payload) {
      state.queue.push({
        id: payload.id,
        label: payload.label,
        fileNames: payload.fileNames || [],
        progress: 0,
        status: "uploading",
        controller: payload.controller,
      });
    },

    PROGRESS(state, { id, progress }) {
      const item = state.queue.find((u) => u.id === id);
      if (item) item.progress = progress;
    },

    FINISH(state, id) {
      const item = state.queue.find((u) => u.id === id);
      if (item) item.status = "done";
    },

    REMOVE(state, id) {
      state.queue = state.queue.filter((u) => u.id !== id);
    },

    ERROR(state, { id }) {
      const item = state.queue.find((u) => u.id === id);
      if (item) item.status = "error";
    },

    CANCELED(state, id) {
      const item = state.queue.find((u) => u.id === id);
      if (item) item.status = "canceled";
    },

    CLEAR(state) {
      state.queue = [];
    },
  },

  actions: {
    start({ commit }, payload) {
      const id = uuid();
      const controller = new AbortController();

      commit("ADD", {
        id,
        label: payload.label,
        fileNames: payload.fileNames,
        controller,
      });

      return { id, controller };
    },

    progress({ commit }, payload) {
      commit("PROGRESS", payload);
    },

    finish({ commit }, id) {
      commit("FINISH", id);

      setTimeout(() => {
        commit("REMOVE", id);
      }, 15000);
    },

    error({ commit }, id) {
      commit("ERROR", { id });

      setTimeout(() => {
        commit("REMOVE", id);
      }, 30000);
    },

    cancelUpload({ state, commit }, id) {
      const item = state.queue.find((u) => u.id === id);
      if (!item) return;

      if (item.controller) {
        item.controller.abort();
      }

      commit("CANCELED", id);

      setTimeout(() => {
        commit("REMOVE", id);
      }, 15000);
    },

    clearUploads({ commit }) {
      commit("CLEAR");
    },
  },
};
